var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"account-avatar",attrs:{"size":_vm.size,"color":_vm.color,"tile":""}},[_c('span',{staticClass:"white--text font-weight-bold text-body-2 account-avatar__initials"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }